"use client";

import Accordion from "@/components/landingPage/Accordion";
import { StandardLpDocument } from "@/gql/graphql";
import { useGraphQL } from "@/utils/useGraphQL";
import Image from "next/image";
import React, { useState } from "react";
import { Program, SLPProgramType, StandardLP } from "@/services/types";
import { extractImage, formatNumber } from "@/utils/strapiTojs";
import { modifyTitle } from "../../utils/Functions/formatString";
import ReactMarkdown from "react-markdown";
import SectionBonuses from "./SectionBonuses";
import SectionNSDC from "./SectionNSDC";
interface Props {
  learnerData: Program | undefined;
  program: StandardLP | undefined;
  programType: SLPProgramType;
}
const KeyOutcomes = (props: Props) => {
  const learnerData = props?.learnerData;
  const {
    data
  } = useGraphQL(StandardLpDocument, {
    productId: learnerData?.product_id.toString()
  });
  const [openText, setOpenText] = useState(false);
  const content = data?.standardLps?.data?.[0]?.attributes?.content;
  return <>
      <div className="wrap section__container--small">
        <div className="left-section">
          {content?.map(item => {
          switch (item?.__typename) {
            case "ComponentStndardLpKeyOutComes":
              return <div key={item?.__typename} className="key-outcomes key-outcomes-1">
                    <p className="pre-header">{item.SmallText}</p>
                    <h2 className="section-header">{item.BigText}</h2>
                    {item.Description && <ReactMarkdown className={`slp section-subheading ${openText ? "" : "section-subheading-mask"}`} components={{
                  ul: ({
                    node,
                    ...props
                  }) => <ul className="list-disc list-outside ml-6 mt-2 space-y-1" {...props} />,
                  li: ({
                    node,
                    ...props
                  }) => <li className="text-base text-gray-700" {...props} />
                }}>
                        {item.Description}
                      </ReactMarkdown>}

                    <button onClick={() => setOpenText(!openText)} className={`read-more-link ${openText ? "read-more-link-open" : ""}`}>
                      {openText ? "Show Less" : "Read More"}
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="15" viewBox="0 0 10 15" fill="none">
                        <path d="M9 7.1875L5 11.1875L1 7.1875" stroke="#002726" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </div>;
            case "ComponentStndardLpWhatYouLearn":
              return <div key={item?.__typename} className="accordion-section">
                    <p className="pre-header">{item.SmallText}</p>
                    <h2 className="section-header">{item.BigText}</h2>
                    <div className="accordion">
                      {item.ModuleDetail?.map((item, index) => <Accordion key={index} label={item?.SmallText ?? ""} title={item?.BigText ?? ""} content={item?.Description ?? ""} />)}
                    </div>
                  </div>;
            case "ComponentStndardLpTargetAudience":
              const audience = item.AudienceDetail?.map(audience => ({
                label: audience?.Title,
                icon: extractImage(audience?.icon)
              }));
              return <div key={item.__typename} className="crash-course-section">
                    <p className="pre-header">{item.SmallText}</p>
                    <h2 className="section-header">{item.BigText}</h2>
                    <p className="section-subheading">{item.Description}</p>
                    <div className="crash-course-wrap">
                      {audience?.map((audience, index) => <div key={index} className="items">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M3.75 11.0227L7.76786 15L15 6.25" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <label>{audience?.label}</label>
                        </div>)}
                    </div>
                  </div>;
            case "ComponentStndardLpModuleDetail":
              return <div key={item.__typename} className="meet-mentors">
                    <p className="pre-header">{item.SmallText}</p>
                    <h2 className="section-header">
                      {modifyTitle(item.BigText ?? "", props.program?.attributes.premium_mentors.data.length ?? -1)}
                    </h2>
                    <p className="section-subheading">{item.Description}</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {props.program?.attributes.premium_mentors.data
                  // ?.slice(0, 2)
                  .map((mentor, index) => <div key={index} className="identity">
                            <div className="identity-img">
                              {" "}
                              <Image src={mentor.attributes.mentorImage.data?.attributes.url || ""} alt="mentor" height={40} width={40} loading="lazy" />
                            </div>
                            <div className="mentor">
                              <label className="name">
                                {mentor.attributes.name}
                              </label>
                              <label className="title">
                                {mentor.attributes.designation && mentor.attributes.designation + ", "}
                                {mentor.attributes.companyName}
                              </label>
                            </div>
                          </div>)}
                    </div>
                  </div>;
            case "ComponentStndardLpCertificate":
              return <div key={item.__typename} className="before-you-ask-wrap">
                    <p className="pre-header">{item.SectionInfo?.SmallText}</p>
                    <h2 className="section-header">
                      {item.SectionInfo?.BigText}
                    </h2>
                    <p className="para">{item.SectionInfo?.Description}</p>
                    <div className="certificate-img">
                      <Image src={extractImage(item.Image).src} alt={extractImage(item.Image).alt} height={431} width={631} loading="lazy" />
                    </div>
                  </div>;
          }
        })}

          <SectionNSDC data-sentry-element="SectionNSDC" data-sentry-source-file="KeyOutcomes.tsx" />

          {props.programType === SLPProgramType.MENTORSHIP && (props.program?.attributes.standard_lp_bonuses.data.length ?? 0) > 0 && <SectionBonuses bigText={"Exclusive bonuses waiting for you!"} smallText={"Exclusive bonuses available to the first 50 enrollees only. Secure your spot now!"} cards={props.program?.attributes.standard_lp_bonuses.data || []} />}

          {content?.map(item => {
          switch (item?.__typename) {
            case "ComponentStndardLpFaqDetail":
              return <div key={item.__typename} className="container faq-container">
                    <p className="pre-header">{item?.SmallText}</p>
                    <h2 className="section-header">{item?.BigText}</h2>
                    <div className="accordion">
                      {item?.FaqDetail?.map((item, index) => <Accordion key={index} title={item?.question ?? ""} content={item?.answer ?? ""} />)}
                    </div>
                  </div>;
          }
        })}
        </div>
        {content?.map(item => {
        switch (item?.__typename) {
          case "ComponentStndardLpLearnerDetail":
            const repeatedStudentsImages = [...(Array.isArray(item.Students) ? item.Students : []), ...(Array.isArray(item.Students) ? item.Students : []), ...(Array.isArray(item.Students) ? item.Students : []), ...(Array.isArray(item.Students) ? item.Students : []), ...(Array.isArray(item.Students) ? item.Students : []), ...(Array.isArray(item.Students) ? item.Students : []), ...(Array.isArray(item.Students) ? item.Students : []), ...(Array.isArray(item.Students) ? item.Students : [])];
            return <div className="right-section">
                  <div className="learners-block">
                    <div className="marquee-container">
                      <div className="marquee-container-header">
                        <h2>
                          {formatNumber(item.StudentCount).number}
                          {formatNumber(item.StudentCount).shortHand}+{" "}
                          {item.StudentText}
                        </h2>
                        <p>{item.StudentDescription}</p>
                      </div>
                      <div className="section__hero-lerners-marquee">
                        <div className="section__hero-lerners-marquee-slider">
                          {repeatedStudentsImages?.map((student, index) => <div key={index} className="section__hero-lerners-marquee-card">
                              <div className="section__hero-lerners-marquee-card-img">
                                <Image src={extractImage(student?.StudentImage).src} width={86} height={86} loading="lazy" alt={extractImage(student?.StudentImage).alt ?? "Learner working at"} />
                              </div>
                              <div className="section__hero-lerners-marquee-card-brand">
                                <Image src={extractImage(student?.CompanyImage).src} width={88} height={108} loading="lazy" alt={extractImage(student?.CompanyImage).alt ?? "Brand Name"} />
                              </div>
                            </div>)}
                        </div>
                      </div>{" "}
                    </div>
                    <ul className="">
                      {item.LearnerInfo?.map((info, index) => <li key={index} className="">
                          <Image src={"/images/new/tick.svg"} alt={"tick"} height={25} width={25} loading="lazy" />
                          <p>{info?.Description}</p>
                        </li>)}
                    </ul>
                    <div className="logo-sec">
                      <div className="w-divider">
                        <Image src={extractImage(item.CompanyLogo).src} alt={extractImage(item.CompanyLogo).alt ?? "logo"} height={47} width={109} loading="lazy" />
                      </div>
                      <div className="logo-sec-linkedin">
                        <Image src={extractImage(item.SocialIcon).src} alt={extractImage(item.SocialIcon).alt ?? "logo"} height={47} width={109} loading="lazy" />
                        <div className="logo-sec-linkedin-text">
                          <span>{item?.SmallText ?? ""}</span>
                          {item?.BigText ?? ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>;
        }
      })}
      </div>
    </>;
};
export default KeyOutcomes;
export const accordionData = [{
  title: "Section 1",
  content: `A detailed examination of Autoninja, a vertical SaaS company serving the automotive industry, provides insights into the practical application and impact of SaaS. This case study illustrates how Autoninja leveraged SaaS to revolutionize operations for auto dealerships, improve customer experiences, and drive significant revenue growth despite the challenges of technology adoption in a traditionally low-tech sector.`
}, {
  title: "Section 2",
  content: `A detailed examination of Autoninja, a vertical SaaS company serving the automotive industry, provides insights into the practical application and impact of SaaS. This case study illustrates how Autoninja leveraged SaaS to revolutionize operations for auto dealerships, improve customer experiences, and drive significant revenue growth despite the challenges of technology adoption in a traditionally low-tech sector.`
}, {
  title: "Section 3",
  content: `A detailed examination of Autoninja, a vertical SaaS company serving the automotive industry, provides insights into the practical application and impact of SaaS. This case study illustrates how Autoninja leveraged SaaS to revolutionize operations for auto dealerships, improve customer experiences, and drive significant revenue growth despite the challenges of technology adoption in a traditionally low-tech sector.`
},, {
  title: "Section 4",
  content: `A detailed examination of Autoninja, a vertical SaaS company serving the automotive industry, provides insights into the practical application and impact of SaaS. This case study illustrates how Autoninja leveraged SaaS to revolutionize operations for auto dealerships, improve customer experiences, and drive significant revenue growth despite the challenges of technology adoption in a traditionally low-tech sector.`
},, {
  title: "Section 5",
  content: `A detailed examination of Autoninja, a vertical SaaS company serving the automotive industry, provides insights into the practical application and impact of SaaS. This case study illustrates how Autoninja leveraged SaaS to revolutionize operations for auto dealerships, improve customer experiences, and drive significant revenue growth despite the challenges of technology adoption in a traditionally low-tech sector.`
},, {
  title: "Section 6",
  content: `A detailed examination of Autoninja, a vertical SaaS company serving the automotive industry, provides insights into the practical application and impact of SaaS. This case study illustrates how Autoninja leveraged SaaS to revolutionize operations for auto dealerships, improve customer experiences, and drive significant revenue growth despite the challenges of technology adoption in a traditionally low-tech sector.`
},, {
  title: "Section 7",
  content: `A detailed examination of Autoninja, a vertical SaaS company serving the automotive industry, provides insights into the practical application and impact of SaaS. This case study illustrates how Autoninja leveraged SaaS to revolutionize operations for auto dealerships, improve customer experiences, and drive significant revenue growth despite the challenges of technology adoption in a traditionally low-tech sector.`
}];